var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('span',[_vm._v("\n    "+_vm._s(_vm.$t(_vm.option.text))+"\n  ")]),(_vm.nb)?_c('b-badge',[_vm._v("\n    "+_vm._s(_vm.nb)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }